module.exports = __webpack_public_path__ + "static/img/zg2.49b96e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/zg2.jpg
// module id = 18kK
// module chunks = 1